export default __webpack_public_path__ + "static/media/1515FE08-6EB5-4B97-8F26-65573AC6EE70.3b7f19c5.jpeg";